import { ChangeDetectionStrategy, Component, ElementRef, inject, output } from '@angular/core';
import { ActivitySectionDirective, UserActivityClickTrackingDirective } from '@core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-more-gift-card',
  templateUrl: './gift-card.component.html',
  styleUrl: './gift-card.component.scss',
  imports: [
    ActivitySectionDirective,
    PageHeaderComponent,
    UserActivityClickTrackingDirective,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GiftCardComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly back = output();

}
